/**
 * useThemeEffects Hook
 * Provides access to theme effects configuration for components
 */

import { useTheme } from '@/lib/theme'
import { type ThemeEffectsConfig } from '@/utils/theme-application.util'

export function useThemeEffects() {
  const { databaseTheme } = useTheme()
  const effects = (databaseTheme?.config?.effects || {}) as ThemeEffectsConfig

  /**
   * Get component-specific effects
   * @param component - Component name ('button', 'card', etc.)
   */
  const getComponentEffect = (component: 'button' | 'card') => {
    return effects.components?.[component]
  }

  /**
   * Get global effects
   */
  const getGlobalEffects = () => {
    return effects.global
  }

  /**
   * Check if a specific global effect is enabled
   */
  const isGlobalEffectEnabled = (effectName: keyof NonNullable<ThemeEffectsConfig['global']>) => {
    return effects.global?.[effectName]?.enabled || false
  }

  return {
    effects,
    getComponentEffect,
    getGlobalEffects,
    isGlobalEffectEnabled,
  }
}

